import * as $ from "jquery";
import {Base} from "../Base";
import {arrayLast, nnTrim} from "../util";

/**
 * Any user interface element
 */
export class UIElement extends Base{

    static openUIElements = [];
    static escKeyInitialized = false;
    static allUIElements = [];

    /**
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig) {
        super();
        this.translator = translator;
        this.isMobileDevice = isMobileDevice;
        this.runtimeConfig = runtimeConfig;
        this.onChangeRuntimeConfig = onChangeRuntimeConfig;
        this.id = id;

        if (!UIElement.escKeyInitialized) {
            $('body').keyup(function (e) {
                if (e.key === "Escape" && UIElement.openUIElements.length > 0) {
                    arrayLast(UIElement.openUIElements).close();
                }
            });
            UIElement.escKeyInitialized = true;
        }

        UIElement.allUIElements.push(this);
    }

    /**
     * UI element code
     * @returns {string}
     */
    getCode() {
        return this.id?this.id:'NOCODE';
    }

    getCodeHtmlClass() {
        return this.getCode()
            .replaceAll(".","_")
            .replaceAll("#","_");
    }

    /**
     * The element to be added to DOM
     * @return {jQuery}
     */
    getUIElement() {
    }

    /**
     * When the given element is focus-visible, detect space or enter key up and run given callback
     * A second call to this method will add a new callback to the given elem
     * @param callback {function}
     * @param elem {jQuery|undefined} The element to detect focus-visible on. if undefined, uses this.getUIElement()
     */
    onFocusedEnterOrSpace(callback,elem = undefined){
        elem = elem?elem:this.getUIElement();
        elem.on('keyup', event=>{
            if(elem.is(":focus-visible")){
                let keycode = (event.keyCode ? event.keyCode : event.which);
                if(keycode===13||keycode===32){
                    callback();
                }
            }
        })
    }

    /**
     * An ID token to use for logging
     * @return {string}
     */
    getLogId() {
        return nnTrim(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }

    /**
     * log stat entry for this UIElement
     * @param action {string}
     * @param store {boolean} if true, stores immediately
     */
    logStat(action, store=false) {
        if(tumbo && tumbo.STATS)
            tumbo.STATS.log(this, action, store);
    }

    /**
     * This function sets values related to the UI size and position
     * @param isSmallContainerWidth {boolean} Is this a small width application container?
     * @param isSmallContainerHeight {boolean} Is this a small height application container?
     * @param width {number} The with of the container in pixels (integer)
     * @param height {number} The height of the container in pixels (integer)
     * @param containerAbsolutePosition {Object} the absolute position of the container {top:, left:}
     */
    setContainerSizeAndPosition(isSmallContainerWidth, isSmallContainerHeight, width, height, containerAbsolutePosition) {
        const changed = this.isSmallContainerWidth !== isSmallContainerWidth || this.isSmallContainerHeight !== isSmallContainerHeight;
        this.isSmallContainerWidth = isSmallContainerWidth;
        this.isSmallContainerHeight = isSmallContainerHeight;
        this.containerWidth = width;
        this.containerHeight = height;
        this.containerAbsolutePosition = containerAbsolutePosition;
        if (changed) {
            this.onSmallContainer();
        }
    }

    /**
     * This function is called whenever the container size changes enough to be considered small or not small
     * Should be redefined by subclasses to react to the change
     */
    onSmallContainer() {
    }

    /**
     * Is a value defined for the given key
     * @param prop {string} A property key
     * @return {*}
     */
    hasSessionProp(prop) {
        return this.runtimeConfig.hasUIElementSessionProp(this.id, prop);
    }

    /**
     * Get a value by property key
     * @param prop {string} A property key
     * @param defValue {*}
     * @return {*}
     */
    getSessionProp(prop, defValue=undefined) {
        const val = this.runtimeConfig.getUIElementSessionProp(this.id, prop);
        return val!==undefined && val!==null? val : defValue;
    }

    /**
     * Set a property value that lasts for this session (ends on close tab)
     * @param prop {string} A property key
     * @param value {*} any value
     * @return {UIElement} This UIElement
     */
    setSessionProp(prop, value) {
        this.runtimeConfig.setUIElementSessionProp(this.id, prop, value);
        return this;
    }

    /**
     * Remove a property
     * @param prop {string} A property key
     * @return {UIElement} This UIElement
     */
    removeSessionProp(prop) {
        this.runtimeConfig.removeUIElementSessionProp(this.id, prop);
        return this;
    }

    /**
     * Close this UI element
     * Override when necessary
     */
    close() {
    }
}